import i18n from 'i18n';

export class ScreenService {
  static getDocumentTitle(title: string) {
    return i18n.t('global.documentTitle', { title });
  }
}
